import {forwardRef, useImperativeHandle, useState} from 'react';
import {Button, Modal} from 'antd-mobile';
import {cn, goTo, toPriceStr} from '@/utils';
import React from 'react';
import LuckyspinWinAnimationWeb from '@/common-pages/luckyspin/luckyspin-win-animation-web';
import {useTranslation} from 'react-i18next';
import {useSequentialModalContext} from '@/components/basic/sequential-modal/context';
import {homePage} from '@/config';

export interface PrizeData {
  name: string;
  pic: string;
  isActual: boolean;
  customerImUrl?: string;
}

export interface PrizeModalProps {
  className?: string;
}

export interface PrizeRef {
  show: (info: PrizeData) => void;
}

// 生成随机玩家名称 - 前4位手机号****后两位格式
const generateRandomPlayerName = () => {
  // 生成前4位随机数字
  const prefix = Math.floor(1000 + Math.random() * 9000).toString();
  // 生成后2位随机数字
  const suffix = Math.floor(10 + Math.random() * 90).toString();
  return `${prefix}****${suffix}`;
};

export function getDisplayPrizeName(prizeName: string) {
  if (prizeName.includes('gameCoin')) {
    return toPriceStr(+prizeName.split('x')[1], {fixed: 0});
  }
  return prizeName;
}

export interface UserTopDataItem {
  player: string;
  prize: string;
  isActual?: boolean;
}

// 生成假数据的方法
export const generateMockData = (
  prizeList: PrizeData[],
  notActualCount: number = 0,
  actualCount: number = 0,
): UserTopDataItem[] => {
  if (!prizeList || prizeList.length === 0) {
    return [];
  }

  const mockData: UserTopDataItem[] = [];

  // 分离实物和非实物奖品
  const actualPrizes = prizeList.filter(prize => prize.isActual);
  const notActualPrizes = prizeList.filter(prize => !prize.isActual);

  // 生成指定数量的非实物奖品
  for (let i = 0; i < notActualCount && notActualPrizes.length > 0; i++) {
    const randomPrize =
      notActualPrizes[Math.floor(Math.random() * notActualPrizes.length)];
    const randomPlayer = generateRandomPlayerName();

    mockData.push({
      player: randomPlayer,
      prize: randomPrize.name,
      isActual: false,
    });
  }

  // 生成指定数量的实物奖品
  for (let i = 0; i < actualCount && actualPrizes.length > 0; i++) {
    const randomPrize =
      actualPrizes[Math.floor(Math.random() * actualPrizes.length)];
    const randomPlayer = generateRandomPlayerName();

    mockData.push({
      player: randomPlayer,
      prize: randomPrize.name,
      isActual: true,
    });
  }

  return mockData;
};

const PrizeModal = forwardRef<PrizeRef, PrizeModalProps>(({className}, ref) => {
  const [visible, setVisible] = useState(false);
  const [prizeName, setPrizeName] = useState('');
  const [prizePic, setPrizePic] = useState('');
  const [isActual, setIsActual] = useState(false);
  // const [customerImUrl, setCustomerImUrl] = useState('');
  const {t} = useTranslation();

  useImperativeHandle(ref, () => ({
    show: (_info: PrizeData) => {
      setVisible(true);
      setPrizeName(getDisplayPrizeName(_info.name));
      setPrizePic(_info.pic);
      setIsActual(_info.isActual);
      // setCustomerImUrl(_info?.customerImUrl || '');
    },
  }));
  const {onClose} = useSequentialModalContext();

  const handleClose = () => {
    setVisible(false);
  };

  const handleGet = () => {
    if (isActual) {
      goTo(homePage, {
        screen: 'Chat',
        // params: {
        //   customerId: customerImUrl,
        // },
      });
      onClose();
    }
    setVisible(false);
  };

  return (
    <>
      <LuckyspinWinAnimationWeb className="size-1 fixed -top-[9999px] -left-[9999px]" />
      <Modal
        bodyClassName={cn(
          'bg-transparent [&_div.adm-modal-content]:px-0',
          className,
        )}
        getContainer={() => document.body}
        visible={visible}
        onClose={handleClose}
        showCloseButton={false}
        content={
          <div className="flex flex-col items-center" onClick={handleClose}>
            <h2 className="text-center text-4xl font-bold text-[#FFF8C3] -mb-2 [text-shadow:_2px_2px_0_#BF5E34,_-2px_-2px_0_#BF5E34,_2px_-2px_0_#BF5E34,_-2px_2px_0_#BF5E34]">
              {prizeName}
            </h2>
            <div className="relative">
              <LuckyspinWinAnimationWeb className="size-[18.75rem]" />
              <div
                className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 size-[12.5rem] bg-full bg-no-repeat"
                style={{
                  backgroundImage: `url(${prizePic})`,
                }}
              />
            </div>
            <Button
              className={cn(
                'h-[2.375rem] rounded-full p-0 m-0 text-[#6F0F00] font-semibold uppercase text-base',
                !isActual && 'w-[6.0625rem]',
                isActual && 'px-6',
              )}
              style={{
                background:
                  'linear-gradient(180deg, #FFFDE2 0%, #FBE88A 35.5%, #B47D2D 72.5%, #B47D2D 80%, #F6C74E 98%)',
                boxShadow:
                  '0px 2px 1px 0px #FFF inset, 0px -2px 1px 0px #FFFF54 inset',
              }}
              onClick={handleGet}>
              {isActual ? t('spinActual.label.supportToClaim') : t('label.get')}
            </Button>
          </div>
        }
        closeOnMaskClick
      />
    </>
  );
});

export default PrizeModal;
